import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import { loadIdentityCustoms } from './asyncThunk';

const initThemesState = {
  dark: undefined,
  light: undefined,
};

const initBrandsState = {
  name: undefined,
  standbyBrandActive: true,
  icons: {
    largeLight: undefined,
    largeDark: undefined,
    largeColored: undefined,
    compactLight: undefined,
    compactDark: undefined,
  },
  backgrounds: {
    colored: undefined,
    dark: undefined,
    light: undefined,
  },
};

const initCoversState = {
  videos: {
    background: undefined,
    carousel: [],
    screensaver: undefined,
  },
};

// ------ App Identity | Tiene la informacion del tema customizado e identidad de Company Biometrics --------
const identityInitialState = {
  customs: {
    themes: initThemesState,
    brands: initBrandsState,
    covers: initCoversState,
  },
  isLoadingData: false,
  errors: undefined,
  success: false,
};

const identitySlice = createSlice({
  name: 'identity',
  initialState: identityInitialState,
  reducers: {
    setThemes: (state, { payload }) => {
      state.customs.themes = payload.themes;
    },
    setStandbyBrand: (state, { payload }) => {
      state.customs.brands.standbyBrandActive = payload.standbyBrandActive;
    },
  },
  extraReducers: {
    [loadIdentityCustoms.fulfilled]: (state, { payload }) => {
      const { customs } = payload;
      return _.merge({}, state, { customs, isLoadingData: false, errors: undefined, success: true });
    },
    [loadIdentityCustoms.pending]: (state) => {
      return _.merge({}, state, { isLoadingData: true });
    },
    [loadIdentityCustoms.rejected]: (state, { payload }) => {
      const errors = payload;
      return _.merge({}, state, { isLoadingData: false, errors, success: false });
    },
  },
});

export const { setThemes, setStandbyBrand } = identitySlice.actions;
export default identitySlice.reducer;
